import angular from 'angular';

const notificationStreamIcon = angular.module('notificationStreamIcon', [
  'robloxApp',
  'notificationStream',
  'notificationStreamIconHtmlTemplate'
]);

export default notificationStreamIcon;
